import { render, staticRenderFns } from "./cgu.vue?vue&type=template&id=5e5de882&"
import script from "./cgu.vue?vue&type=script&lang=js&"
export * from "./cgu.vue?vue&type=script&lang=js&"
import style0 from "./cgu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports